import Reveal from "@/components/base/Reveal";
import { searchIntents } from "@/mocks/home";

export default function SearchIntent() {
  return (
    <section id="intent" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
              Search Intents
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              常见检索词分别指向什么
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              不同检索词背后的诉求并不一样。对照下表，可以更快判断自己需要的是字幕、配音，还是可在线切换的字幕形式。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {searchIntents.map((item, index) => (
            <Reveal key={item.keyword} delay={index * 60}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className="ri-search-eye-line text-lg" aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.keyword}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.intent}</p>
                <p className="mt-3 flex-1 border-t border-background-200 pt-3 text-xs leading-relaxed text-foreground-600">
                  {item.note}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}